import { TaxCaseQuery } from "../../../../../../../api/graphql/queries/taxCase/taxCase.generated";
import { QuestionnaireType } from "../../../../../../../api/graphql/schema.generated";
import { EOY_INCOME_TAX_QUESTIONNAIRE_TYPES } from "./constants";

export type TaxCase = NonNullable<TaxCaseQuery["taxCase"]>;

/** A date means finalized; null means still open. */
export type Completeness = { notRelevant: true } | { date: string | null };

export const getBusinessCompleteness = (taxCase: TaxCase): Completeness =>
  taxCase.businessSectionNotRelevantAt
    ? { notRelevant: true }
    : { date: taxCase.businessTaxFinalizedAt ?? null };

// Skipping income tax also sets incomeTaxFinalizedAt, so check it first.
// Companies have no private part: all income tax types are unavailable.
export const getPrivateCompleteness = (
  taxCase: TaxCase,
  unavailableTypes: QuestionnaireType[]
): Completeness =>
  taxCase.incomeTaxSkippedAt ||
  EOY_INCOME_TAX_QUESTIONNAIRE_TYPES.every((type) =>
    unavailableTypes.includes(type)
  )
    ? { notRelevant: true }
    : { date: taxCase.incomeTaxFinalizedAt ?? null };
